import State from '../interfaces/states/State';

import CommunicationData from '../interfaces/CommunicationData';

export const communicationData$ = (state: State): CommunicationData => state.communication.communicationData;

export const isLoadingCommunication$ = (state: State): boolean => state.communication.isLoading;

export const hasCommunicationData$ = (state: State): boolean => state.communication.communicationData.data.length > 0;
